<template>
  <div class="receipt-page">
    <div class="card card-custom gutter-b h-100">
      <div class="card-header">
        <div class="card-title">
          Danh sách phiếu thu
        </div>
      </div>
      <!--    body-->
      <div class="card-body">
        <div class="row">
          <div class="col-md-2 col-sm-12 mb-3">
            <h4 style="font-size: 13px">Thời gian</h4>
            <el-date-picker
                v-model="query.date_range"
                type="daterange"
                style="width: 100%"
                range-separator="-"
                start-placeholder="Bắt đầu"
                @change="changeValue"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                end-placeholder="kết thúc">
            </el-date-picker>
          </div>

          <div class="col-md-2 col-sm-12 mb-3">
            <h4 style="font-size: 13px">Mã phiếu thu</h4>
            <el-input placeholder="Nhập mã phiếu thu" maxlength="30" clearable @input="changeValue" v-model="query.receipt_code" ></el-input>
          </div>

          <div class="col-md-2 col-sm-12 mb-3">
            <h4 style="font-size: 13px">Trung tâm</h4>
            <el-select filterable v-model="query.center_id" @change="handleCenter" clearable placeholder="Chọn trung tâm">
              <el-option :value="center.id" :key="center.id" :label="center.name" v-for="center in listCenter"></el-option>
            </el-select>
          </div>

          <div class="col-md-2 col-sm-12 mb-3">
            <h4 style="font-size: 13px">Chi nhánh</h4>
            <el-select v-model="query.branch_id" filterable @change="changeValue" clearable placeholder="Chọn Chi nhánh">
              <el-option :value="branch.id" :key="branch.id" :label="`${branch.name}`" v-for="branch in listBranch"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mt-10">
          <table class="table table-bordered text-center" style="min-width: 1200px;">
            <thead>
            <tr style="background-color: #F8F8F8; font-size: 13px">
              <th style="width: 200px">Mã phiếu thu</th>
              <th style="width: 150px">Mã học viên</th>
              <th style="width: 230px">Tên học viên</th>
              <th style="width: 150px">Số điện thoại</th>
              <th style="width: 150px">Mã hợp đồng</th>
              <th style="width: 100px">Số tiền</th>
              <th style="width: 200px">Người nạp</th>
              <th style="width: 250px">Cách thức thanh toán</th>
              <th style="width: 150px">Chi nhánh</th>
              <th style="width: 200px">Ngày nạp</th>
              <th style="width: 250px">Ghi chú</th>
            </tr>
            </thead>
            <tbody v-if="items.length === 0">
            <tr>
              <td v-loading="loading" colspan="10">Không có dữ liệu.</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr v-for="(item, index) in items" :key="item.id || index">
              <td>
                <template v-if="currentUser.user.permission.includes(permission.KIEM_TOAN)">
                  <div class="d-flex align-items-center">
                    <input
                        class="form-control form-control-sm"
                        :placeholder="item.receipt_code ? 'Sửa mã phiếu thu' : 'Nhập mã phiếu thu'"
                        maxlength="30"
                        v-model.trim="item._editReceipt"
                        :disabled="item._savingReceipt"
                        @keyup.enter="showSave(item) && saveReceiptCode(item)"
                    style="min-width: 140px"
                    />
                    <button
                        v-if="showSave(item)"
                        class="btn btn-sm btn-primary ml-2"
                        @click="saveReceiptCode(item)"
                    >
                      Lưu
                    </button>
                    <span v-if="item._savingReceipt" class="ml-2">Đang lưu...</span>
                  </div>
                </template>

                <template v-else>
                  <span>{{ (item.receipt_code || '').trim() || '-' }}</span>
                </template>
              </td>
              <td>{{ item.user_id }}</td>
              <td>{{ item.student_name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.contract_id }}</td>
              <td>{{ formatCurrency(item.amount) }}</td>
              <td>{{ item.create_name }}</td>
              <td>{{ item.hinh_thuc_thanh_toan ?? 'Hệ thống' }}</td>
              <td>{{ item.branch_name }}</td>
              <td>{{ item.dated_paid }}</td>
              <td>{{ item.note_receipt }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mb-0 d-flex flex-row-reverse mr-10">
        <p class="mb-0">Tổng số bản ghi: <span class="text-primary ">{{total}}</span></p>
      </div>
      <div class="edu-paginate mx-auto text-center mt-10 ">
        <paginate
            v-model="page"
            :page-count="last_page"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'"
            :next-link-class="'next-link-item'"
            :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-class="'page-item'"
        >
        </paginate>
      </div>
      <el-dialog class="type-audit" title="Xử lý lỗi kiểm toán"  width="30%" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="form"  >
          <el-form-item label="Ghi chú" >
            <el-input type="textarea" placeholder="Nhập ghi chú" v-model="form.note" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Đánh dấu đã xử lý" prop="status">
            <el-select v-model="form.status" style="width: 100%" placeholder="Chọn trạng thái xử lý">
              <el-option label="Đã xử lý" value="4"></el-option>
              <el-option label="Chưa xử lý" value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Hủy bỏ</el-button>
          <el-button :loading="loadingSave" style="background: #5D04B0; color: white" @click="submitForm('form')" >Xác nhận</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_STUDENT_AMOUNT_RECEIPT, UPDATE_STUDENT_AMOUNT_RECEIPT } from "@/core/services/store/audit/audit.module";
import { GET_CENTERS } from "@/core/services/store/center/centers.module";
import { GET_LIST_BRANCH_IS_EDUTALK } from "@/core/services/store/test/testInput.module";
import {mapGetters} from "vuex";

export default {
  name: "AuditList",
  data() {
    return {
      loading: false,
      query: {
        date_range: null,
        branch_id: null,
        center_id: null,
        status: null,
        keyword: null,
        receipt_code: ""
      },
      listBranch: [],
      listCenter: [],
      items: [],
      page: 1,
      last_page: 0,
      total: 0,
      dialogVisible: false,
      loadingSave: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      form: {
        note: "",
        status: "",
        id: 0
      },
      rules: {
        status: [{ required: true, message: "Chọn trạng thái xử lý", trigger: "blur" }]
      },
      _debounceTimer: null
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Kiểm toán", route: "" },
      { title: "Danh sách phiếu thu" }
    ]);
    // lấy query trên URL (nếu có)
    this.query = { ...this.query, ...this.$router.currentRoute.query };
    await this.getListBranchIsEdutalk();
    this.getCenters();
    this.getList();
  },
  methods: {
    formatCurrency(val) {
      const n = Number(val || 0);
      return n.toLocaleString("vi-VN");
    },

    changeValueDebounced() {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this._applyQueryAndFetch(), 400);
    },

    changeValue() {
      this.changeValueDebounced();
    },

    _applyQueryAndFetch() {
      const cleaned = Object.keys(this.query).reduce((acc, k) => {
        const v = this.query[k];
        if (v !== null && v !== undefined && v !== "") acc[k] = v;
        return acc;
      }, {});
      const query = { page: this.page, ...cleaned };

      this.$router.push({
        name: "receipt-list",
        query: { ...query, t: String(Date.now()) }
      });
      this.getList();
    },

    async getListBranchIsEdutalk() {
      return this.$store
          .dispatch(GET_LIST_BRANCH_IS_EDUTALK, {
            center_id: this.query.center_id ? [this.query.center_id] : [516, 295]
          })
          .then(res => {
            this.listBranch = [{ name: "Tất cả", id: 0 }, ...(res.data || [])];
          });
    },

    handleCenter() {
      this.query.branch_id = "";
      this.listBranch = [];
      this.getListBranchIsEdutalk();
      this.changeValue();
    },

    getList() {
      this.loading = true;
      this.$store
          .dispatch(GET_STUDENT_AMOUNT_RECEIPT, { page: this.page, ...this.query })
          .then(data => {
            this.items = data.data ?? [];
            this.total = data.pagination.total;
            this.page = data.pagination.page;
            this.last_page = data.pagination.last_page;
            this.items.forEach(i => {
              this.$set(i, "_editReceipt", (i.receipt_code || "").trim());
            });
            this.loading = false;
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
          });
    },

    getCenters() {
      this.$store.dispatch(GET_CENTERS, { limit: 10000, status: 1, is_edutalk: 1 }).then(res => {
        this.listCenter = (res.data && res.data.data) || [];
      });
    },

    clickCallback(p) {
      this.page = p;
      this.getList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    submitForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) return;
        this.loadingSave = true;
        this.$store
            .dispatch(UPDATE_STUDENT_AMOUNT_RECEIPT, {
              id: this.form.id,
              status: this.form.status,
              note: this.form.note
            })
            .then(() => {
              this.$message.success("Cập nhật thành công");
              this.dialogVisible = false;
              this.getList();
            })
            .catch(() => {
              this.$message.error("Cập nhật thất bại");
            })
            .finally(() => {
              this.loadingSave = false;
            });
      });
    },

    async saveReceiptCode(item) {
      const code = ((item._editReceipt ?? item._newReceiptCode) || "").trim();
      const current = (item.receipt_code || "").trim();

      if (!code) return;
      if (code === current) return; // không thay đổi thì bỏ

      if (item._savingReceipt === undefined) {
        this.$set(item, "_savingReceipt", false);
      }
      this.$set(item, "_savingReceipt", true);

      try {
        const res = await this.$store.dispatch(UPDATE_STUDENT_AMOUNT_RECEIPT, {
          id: item.id,
          receipt_code: code,
        });

        this.$set(item, "receipt_code", code);
        this.$set(item, "_editReceipt", code);
        this.$set(item, "_newReceiptCode", "");
        this.$message.success(res?.message || "Đã lưu mã phiếu thu");
      } catch (e) {
        const msg = e?.data?.message || "Có lỗi xảy ra khi lưu mã phiếu thu";
        this.$message.error(msg);
      } finally {
        this.$set(item, "_savingReceipt", false);
      }
    },

    showSave(item) {
      const edited  = (item._editReceipt || '').trim();
      const current = (item.receipt_code || '').trim();
      return !item._savingReceipt && edited.length > 0 && edited !== current;
    },

  },

  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>
